import { Card } from '@bancobarigui/barihaus';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { InspectionTypeDistribution } from '../types';
import { EmptyState } from './EmptyState';

ChartJS.register(ArcElement, Tooltip, Legend);

interface InspectionTypePieChartProps {
  data: InspectionTypeDistribution[];
  loading?: boolean;
  onSegmentClick?: (typeName: string) => void;
}

export function InspectionTypePieChart({ data, loading = false, onSegmentClick }: InspectionTypePieChartProps) {
  const chartData = {
    labels: data.map(item => item.name),
    datasets: [
      {
        data: data.map(item => item.value),
        backgroundColor: data.map(item => item.color),
        borderColor: '#ffffff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (_event: any, elements: any[]) => {
      if (elements.length > 0 && onSegmentClick) {
        const index = elements[0].index;
        const typeName = data[index].name;
        onSegmentClick(typeName);
      }
    },
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          padding: 15,
          usePointStyle: true,
        },
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            const label = context.label || '';
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1).replace('.', ',');
            return `${label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  const hasData = data && data.length > 0 && data.some(item => item.value > 0);

  return (
    <Card title="Distribuição por Tipo de Inspeção" bordered={false} loading={loading} style={{ height: '100%' }}>
      {!hasData ? (
        <EmptyState />
      ) : (
        <div style={{ height: '300px' }}>
          <Doughnut data={chartData} options={options} />
        </div>
      )}
    </Card>
  );
}
